import { useEffect, useState } from "react";
import Api from "lib/api/httpRequestHelper";
import Logos from "assets/img/logos/group.png";

import DesignSystemButton from "components/_refactor/button/button-ds";
import themeColorsDesingSystem from "assets/theme/ds-colors";
import { Grid, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles({
  images: {
    backgroundColor: themeColorsDesingSystem.primary.main,
    display: "flex",
    justifyContent: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "90vh",
    padding: "2rem",
  },
  Typography: {
    textAlign: "center",
  },
  imageWrapper: {
    position: "relative",
    width: "80px",
    height: "80px",
  },
  removeImageButton: {
    position: "absolute",
    top: -14,
    right: -14,
    padding: "4px 7px",
    backgroundColor: "white",
    "&:hover": {
      backgroundColor: "white",
    },
  },
  hiddenInput: {
    display: "none",
  },
});

export default function NFe() {
  const classes = useStyles();
  const params = window.location.href.split("?")[1];
  const hashNf = params.split("&")[0].split("=")[1];
  const idPessoaLoja = params.split("&")[1].split("=")[1];
  const name = params.split("&")[2].split("=")[1];
  const [Nfe, setNfe] = useState(null);
  const [searching, setSearching] = useState(true);

  const handleSearchNf = async () => {
    try {
      const json = {
        chaveNf: hashNf,
        idPessoaLoja,
      };
      const response = await Api.post(
        "link-order-xml-pdf",
        "order",
        json,
        true
      );
      setNfe(response.Result);
      setSearching(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handleSearchNf();
  }, [hashNf]);

  return (
    <div>
      <Grid item xs={12} class={classes.images}>
        <img
          src={Logos}
          alt="logo"
          style={{
            height: "10vh",
            width: "fit-content",
          }}
        />
      </Grid>
      <Grid container style={{ margin: 0 }} class={classes.container}>
        <Grid
          item
          style={{
            display: "flex",
            flexDirection: "column",
            justifyItems: "center",
            alignItems: "center",
          }}
        >
          {searching ? (
            <Typography class={classes.Typography}>
              Carregando NFe...
            </Typography>
          ) : (
            <>
              <Typography class={classes.Typography}>Olá {name},</Typography>
              {Nfe?.LinkPdf ? (
                <>
                  <Typography class={classes.Typography}>
                    Seu documento fiscal esta disponível para download logo
                    abaixo.
                  </Typography>
                  <DesignSystemButton
                    onClick={() => window.open(Nfe?.LinkPdf, "_blank")}
                  >
                    Download
                  </DesignSystemButton>
                </>
              ) : (
                <Typography class={classes.Typography}>
                  Seu documento fiscal esta em processamento, retorne em breve
                  para realizar o download.
                </Typography>
              )}
            </>
          )}
        </Grid>
      </Grid>
    </div>
  );
}
